import React, {useState} from 'react'
import styled from '@emotion/styled'

import {BottomSheet} from '@vio/atlas/BottomSheet'
import {useDeviceLayout} from '@vio/atlas/context/deviceLayout'
import {PopUp} from '@vio/atlas/PopUp'
import {Text} from '@vio/atlas/Text'
import {cssTheme} from '@vio/atlas/themes'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

import {OfferAlertVariant} from './constants'
import {overlayTranslations} from './offerAlertMessages'
import {VariantComponent} from './VariantComponent'

type PropsTypes = {
  totalPriceDiff?: number | undefined
  currency?: string
  variant: OfferAlertVariant
}

const OverlayContent = styled(Text)`
  padding: ${cssTheme.layout.spacing.s300} ${cssTheme.layout.spacing.s200} 0;
  &.--is-desktop {
    padding: ${cssTheme.layout.spacing.s300} ${cssTheme.layout.spacing.s200}
      ${cssTheme.layout.spacing.s500};
  }
`

export const OfferAlertBannerRedesigned = ({
  totalPriceDiff,
  currency,
  variant
}: PropsTypes) => {
  const [isReasonOverlayOpen, setIsReasonOverlayOpen] = useState(false)
  const absolutePrice = totalPriceDiff && Math.abs(totalPriceDiff)
  const {isMobile} = useDeviceLayout()

  const {content, centerContent} = overlayTranslations['price']

  return (
    <>
      <VariantComponent
        variant={variant}
        onClick={() => setIsReasonOverlayOpen(true)}
        price={absolutePrice}
        currency={currency}
      />
      {isMobile ? (
        <BottomSheet
          isOpen={isReasonOverlayOpen}
          onClose={() => setIsReasonOverlayOpen(false)}
          navBarProps={{
            centerContent: <FormattedMessageWrapper {...centerContent} />
          }}
        >
          <OverlayContent variant="bodyM">
            <FormattedMessageWrapper {...content} />
          </OverlayContent>
        </BottomSheet>
      ) : (
        <PopUp
          navBarProps={{
            centerContent: <FormattedMessageWrapper {...centerContent} />
          }}
          isOpen={isReasonOverlayOpen}
          closeAction={() => setIsReasonOverlayOpen(false)}
          width={640}
        >
          <OverlayContent variant="bodyM" className="--is-desktop">
            <FormattedMessageWrapper {...content} />
          </OverlayContent>
        </PopUp>
      )}
    </>
  )
}
